import { track } from './analytics';

export const OFFICIAL_PHONE_DISPLAY = '07 46 09 52 89';
export const OFFICIAL_PHONE_TEL = 'tel:+33746095289';

// Liens officiels Google Business Profile — à renseigner (ne jamais inventer). Vide = bouton masqué.
export const GOOGLE_REVIEWS_URL = 'https://share.google/gqR380HnQ2nEIb9AM';
export const GOOGLE_WRITE_REVIEW_URL = 'https://share.google/gqR380HnQ2nEIb9AM';

// Un seul événement GA4 par clic (aucune donnée personnelle, ce n'est pas une conversion de réservation).
export const trackPhoneClick = (location) => track('click_phone', { phone_location: location });
